import { Link } from "react-router-dom";
import React, { Component } from "react";

class NavLink extends Component {
  render() {
    return <Link {...this.props} />;
  }
}

export default NavLink;
